import type {
  CartBundleDto,
  CartSkuDto,
} from './schemas'
import { initContract } from '@ts-rest/core'
import z from 'zod'
import { ErrorResponseSchema, Identifier } from '../../shared/types'
import {
  UpsertCartSkuBodySchema,
} from './schemas'

const c = initContract()

const options = {
  pathPrefix: '/bundles',
  commonResponses: {
    400: ErrorResponseSchema,
    404: ErrorResponseSchema,
    500: ErrorResponseSchema,
  },
}

export const cartBundlesContract = c.router({
  getBundle: {
    method: 'GET',
    path: '/:bundleId',
    pathParams: z.object({
      bundleId: Identifier,
    }),
    responses: {
      200: c.type<CartBundleDto>(),
    },
  },

  deleteBundle: {
    method: 'DELETE',
    path: '/:bundleId',
    pathParams: z.object({
      bundleId: Identifier,
    }),
    responses: {
      200: c.type<CartSkuDto>(),
    },
  },

  upsertSkuToBundle: {
    method: 'PUT',
    path: '/:bundleId/skus/:productVariantId',
    pathParams: z.object({
      bundleId: Identifier,
      productVariantId: Identifier,
    }),
    body: UpsertCartSkuBodySchema,
    responses: {
      200: c.type<CartSkuDto>(),
    },
  },

  deleteSkuFromBundle: {
    method: 'DELETE',
    path: '/:bundleId/skus/:productVariantId',
    pathParams: z.object({
      bundleId: Identifier,
      productVariantId: Identifier,
    }),
    responses: {
      204: c.noBody(),
    },
  },
}, options)
